import styled, { css } from "styled-components";
import { ITypography, TTypographyTag } from "./typography.type";
import { theme } from "@theme";

const typographyStyles = {
  h1: css`
    font-family: Cormorant;
    font-weight: 600;
    font-size: 24px;
    line-height: 28.8px;
  `,
  h2: css`
    font-family: Inter;
    font-weight: 400;
    font-size: 18px;
    line-height: 21.6px;
  `,
  h3: css`
    font-family: Cormorant;
    font-weight: 600;
    font-size: 18px;
    line-height: 21.6px;
  `,
  h4: css`
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.2px;
  `,
  p: css`
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.8px;
  `,
  a: css`
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.8px;
    text-decoration: underline;
    color: ${theme.palette.primary};
  `,
  label: css`
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 14.4px;
  `,
  small: css`
    font-family: Inter;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
  `,
};

export const Element = styled.div<Required<Pick<ITypography, "as">>>`
  color: ${theme.palette.stroke};
  white-space: break-spaces;
  ${({ as }) => typographyStyles[as as keyof typeof typographyStyles] || ""}
`;
